import React, {useCallback, useState} from "react";
import "./index.scss";
import {ModalPortal} from "features/components/modal";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import Button from "features/components/button";
import {connect} from "react-redux";
import {
    sendRecommendationDataSelector,
    sendRecommendationErrorSelector,
    sendRecommendationLoadingSelector,
    sendRecommendationSuccessSelector
} from "./selectors";
import {sendRecommendationSetShow, sendRecommendationStart} from "./reducer";
import TextArea from "features/components/text-area";

/* istanbul ignore next */
const mapStateToProps = state => ({
    error: sendRecommendationErrorSelector(state),
    loading: sendRecommendationLoadingSelector(state),
    success: sendRecommendationSuccessSelector(state),
    data: sendRecommendationDataSelector(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    sendRecommendationStart,
    sendRecommendationSetShow
};

export const SendRecommendationModal = (props) => {
    const {error, loading, success, data} = props;
    const {sendRecommendationSetShow, sendRecommendationStart} = props;

    const [content, setContent] = useState("");

    const doRequest = useCallback(() => {
        sendRecommendationStart({id: data.id, text: content});
    }, [content, data, sendRecommendationStart]);

    const doCancel = useCallback(() => {
        sendRecommendationSetShow({show: false});
    }, [sendRecommendationSetShow]);

    return <ModalPortal size={"medium"} className={"send-recommendation-modal"}>
        <Title size={34} align={"center"}>{__("modal.send-recommendation.title")}</Title>
        <TextArea value={content} onChange={setContent} placeholder={__("modal.send-recommendation.placeholder")} disabled={loading} />
        {error.inError && <Text size={16} align={"center"} color={"danger"}>{__(error.error)}</Text>}
        {success && <Text size={16} align={"center"} color={"success"}>{__("modal.send-recommendation.success")}</Text>}
        <Button title={__("buttons.send-recommendation-to", [{key: "[name]", value: data.name}])} onClick={doRequest} status={loading ? "loading" : null} icon={"send"} />
        <Button title={__("buttons.cancel")} onClick={doCancel} type={"outlined"} size={"small"} />
    </ModalPortal>
}
export default connect(mapStateToProps, mapDispatchToProps)(SendRecommendationModal);